/**
 * @file DeleteWorkerDialog.jsx
 * @description DeleteWorkerDialog component for displaying and managing delete worker dialog.
 * @component DeleteWorkerDialog
 * @exports DeleteWorkerDialog - Main component for displaying and managing delete worker dialog.
 */

import React from "react";
import { Button, Box } from "@mui/material";
import { WORKER_STRINGS } from "../../../common/constants/ivrModule/workerConstants.js";
import { STRINGS, VARIANTS, BUTTON_COLORS } from "../../../common/constants/commonConstants.js";
import DialogComponent from "../../../common/components/DialogComponent.jsx";

const DeleteWorkerDialog = ({
    open,
    selectedWorker,
    onConfirmDelete,
    onClose,
}) => {
    return (
        <>
            <DialogComponent
                open={open}
                setWidth="xs"
                onClose={onClose}
                title={WORKER_STRINGS.DELETE_WORKER}
                actions={
                    <>
                        <Button
                            variant={VARIANTS.CONTAINED}
                            color={BUTTON_COLORS.PRIMARY}
                            onClick={() => onConfirmDelete(selectedWorker)}
                        >
                            {STRINGS.CONFIRM}
                        </Button>
                    </>
                }
            >
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                    {WORKER_STRINGS.CONFIRM_DELETE} {selectedWorker?.id}?
                </Box>
            </DialogComponent>
        </>
    );
};

export default DeleteWorkerDialog;
